import React from "react";
import { Outlet } from "react-router-dom";

export const OpenLayout = () => {
  // const asyncCheck = async () => {
  //   // TODO: Max to disable auto login for /apps* ???????
  //   await checkSignInStatus();
  // };

  return (
    <div>
      <div style={{ backgroundColor: "#f8f9fa" }}>
        <Outlet />
      </div>
    </div>
  );
};
